module.exports = __webpack_public_path__ + "static/media/no-data-found.feec0855.svg";